export default [
  {
    path: '/halal-check-list',
    name: 'halal-check-list',
    component: () => import('@/views/halal/check-list/CheckList.vue'),
    meta: {
      title: 'Check List Halal',
      requiresAuth: true,
      action: 'browes',
      resource: 'Check List Halal',
      pageTitle: 'Halal',
      breadcrumb: [
        {
          text: 'Check List Halal',
        },
        {
          text: 'List',
          active: true,
        },
      ],
    },
  },
  {
    path: '/halal-check-list/add',
    name: 'add-halal-check-list',
    component: () => import(
      '@/views/halal/check-list/control-check-list/AddEditCheckList.vue'
    ),
    meta: {
      title: 'Add Check List Halal',
      requiresAuth: true,
      action: 'create',
      resource: 'Check List Halal',
      pageTitle: 'Halal',
      breadcrumb: [
        {
          text: 'Check List Halal',
          to: '/halal-check-list',
        },
        {
          text: 'Add',
          active: true,
        },
      ],
    },
  },
  {
    path: '/halal-check-list/edit/:id',
    name: 'edit-halal-check-list',
    component: () => import(
      '@/views/halal/check-list/control-check-list/AddEditCheckList.vue'
    ),
    meta: {
      title: 'Edit Check List Halal',
      requiresAuth: true,
      pageTitle: 'Halal',
      breadcrumb: [
        {
          text: 'Check List Halal',
          to: '/halal-check-list',
        },
        {
          text: 'Edit',
          active: true,
        },
      ],
    },
  },
]
